module.exports = __webpack_public_path__ + "static/media/promotions-disabled-mobile.5feff5a0.png";